import clsx from "clsx";
import styles from "./STButton.module.css";

export const STButton = ({
  children,
  variant = "primary",
  prefix,
  suffix,
  onClick,
  disabled = false,
  loading = false,
  className,
  type = "button",
  ...props
}) => {
  const isDisabled = disabled || loading;

  const setPosition = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - rect.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - rect.top}px`);
  };

  return (
    <button
      className={clsx(
        styles.button,
        styles[variant],
        loading && styles.loading,
        isDisabled && styles.disabled,
        className,
      )}
      data-hover={variant !== "glass" ? "ink" : undefined}
      onMouseEnter={setPosition}
      onMouseLeave={setPosition}
      onClick={onClick}
      disabled={isDisabled}
      {...props}
    >
      <span
        className={clsx(
          styles.content,
          "d-flex align-items-center justify-content-center",
        )}
      >
        {!loading && prefix && <span>{prefix}</span>}
        <span>{children}</span>
        {!loading && suffix && <span>{suffix}</span>}
      </span>

      {loading && <span className={styles.loader} />}
    </button>
  );
};
